import { get } from "@futuri/cloudsso-client/src/client/util";
import { AdminUsersResult } from "@futuri/cloudsso-client/src/client/types/admin";

export const fetchAdminUsers = async ({
  rootGetters,
  commit
}: {
  rootGetters: any;
  commit: any;
}): Promise<void> => {
  const { baseUrl } = rootGetters;
  const result = await get<AdminUsersResult>(`${baseUrl}admin/users`).catch(
    (ex: Error) => {
      console.warn("Exception getting portal data: ", ex);
      location.href = "/auth/cognito";
    }
  );
  console.log("users result: ", result);

  commit("SET_ADMIN_USERS_RESULT", result);
};

export const setCurrentUserEmail = async (
  { commit }: { commit: any },
  id: string
) => {
  console.log("setting edit user email: ", id);
  commit("SET_CURRENT_USER_EMAIL", id);
};

export const closeUserEdit = async ({ dispatch }: { dispatch: any }) => {
  dispatch("setCurrentUserEmail", undefined);
};
